export class TypeAAT {
	nature: string;
	type: string;
	previousType: string;

	constructor(
		nature: string = 'AT',
		type: string = 'I',
		previousType: string = ''
	) {
		this.nature = nature;
		this.type = type;
		this.previousType = previousType;
	}
}

export interface TypeAATState {
	typeAAT?: TypeAAT;
}
